<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab lazy>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Proje Bilgileri
        </template>
        <project-card />
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Dokümanlar
        </template>
        <b-row>
          <b-col
            cols="12"
            md="12"
          >
            <project-files />
          </b-col>
          <b-col
            v-if="userData.secret_files === '1' && controlSecretFiles"
            cols="12"
            md="12"
          >
            <project-secret-files />
          </b-col>
        </b-row>
      </b-tab>
      <b-tab
        :disabled="!dataItem.id"
        lazy
      >
        <template #title>
          <feather-icon icon="FolderIcon" />
          Medya Galeri
        </template>
        <media-card />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BRow,
  BCol,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import ProjectCard from '@/views/Projects/elements/ProjectCard.vue'
import ProjectFiles from '@/views/Projects/elements/ProjectFiles.vue'
import ProjectSecretFiles from '@/views/Projects/elements/ProjectSecretFiles.vue'
import MediaCard from '@/views/Projects/elements/MediaCard.vue'

export default {
  name: 'ProjectItemForm',
  components: {
    MediaCard,
    ProjectSecretFiles,
    ProjectFiles,
    BTabs,
    BTab,
    BRow,
    BCol,
    FeatherIcon,
    ProjectCard,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
    controlSecretFiles() {
      // userData içindeki packageLimits array'inde subject'i PROJECTS_SECRET_FILES olan elemanın limit'i 1 ise true, değilse false döndürür
      if (
        this.userData
          && Array.isArray(this.userData.packageLimits)
      ) {
        const found = this.userData.packageLimits.find(
          item => item.subject === 'PROJECTS_SECRET_FILES',
        )
        return found && found.limit === 1
      }
      return false
    },
  },
}
</script>
